
 

import { useState, useEffect, useRef } from "react";
import Config from "../Config";


function HtmlToPDF(props)
{

    
    const linkRef = useRef(0);

    const[status, setStatus] = useState(0);  //1-start downloading //2-finish downloading
    const[stream, setStream] = useState("");

    const[orientation, setOrientation] = useState(props.orientation);
    const[title, setTitle] = useState(props.title);


    const getData = (html) => {
       
        setStatus(1);

        
        props.mainView.setProgress(-2);

        var req = {
                html: html,
                orientation: orientation,
                title: title
        };

        fetch(  Config.master + '/rest_v1,html_to_pdf', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                          
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                     // var decodedString = atob(res.result.b64);

                     

                      setStream(res.result.b64);                  
                      setStatus(2);

                      setTimeout( ()=>{                    
                        linkRef.current.click();   
                        setStream('');
                    }, 500 );
                    }
         } )     
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    function printElm(handle) {
        

        //pobierz style...


     

        var html  =     `<html>
                           <head>
                               <title></title>

                               <style>
                               
                                         @page {
                                            size: auto;
                                            odd-header-name: MyHeader1;
                                            odd-footer-name: MyFooter1;
                                        }
                                        @page chapter2 {
                                            odd-header-name: MyHeader2;
                                            odd-footer-name: MyFooter2;
                                        }
                                        @page noheader {
                                            odd-header-name: _blank;
                                            odd-footer-name: _blank;
                                        }

                                        table.table
                                        {
                                            width: 100%;
                                            border: none;
                                            border-collapse: collapse;
                                            border-spacing: 0px;
                                            font-size:12px;
                                        }

                                        table.table td
                                        {
                                            border:1px solid #eee;
                                            padding:2px;
                                        }
                                       

                                        tr.header td
                                        {
                                            background-color: #d5ebd3;
                                            color: #000;
                                            text-align: center;
                                        }


                                        .goright {
                                            text-align: right;
                                        }

                                       .gobold {
                                            font-weight: 700;
                                         }

                                         



                                        .e_square_center {
                                                 text-align: center;
                                        }

                                        .e_nbpc {
                                                background-color: rgb(236, 119, 41);
                                            }

                                        .e_nbpc_txt {
                                                color: rgb(236, 119, 41);
                                            }    

                                        .e_nb {
                                               background-color: rgb(5, 17, 189);
                                            }

                                        .e_nb_txt {
                                               color: rgb(5, 17, 189);
                                               
                                            }   
                                        
                                            
                                            
                                          .e_black {
                                                background-color: rgb(22, 22, 22)!important;
                                            }   

                                        .e_squere {
                                            width: 12px;
                                            height: 12px;
                                            display: inline-block;
                                            vertical-align: middle;
                                            cursor: pointer;
                                            }

                                         

                                        .e_squere_sb {
                                            background-color: #eee;
                                            }

                                        .e_squere_nd {
                                            background-color: #ddd;
                                            }

                                       .e_squere_free
                                        {
                                        background-color: #f99;
                                        }

                                      tr.sums td { 
                                            background-color: #eee;
                                            font-weight: bold;
                                       }  

                                      .goright { text-align: right; }
                                      .gocenter { text-align: center; }
                                      .gobold { font-weight: 700; }





                                      

                                        .calSchedule
                                        {
                                        width: 100%;
                                        }


                                        .calSchedule .schedTab
                                        {
                                        width: 100%;
                                        }

                                        .calSchedule .schedTab tr.days
                                        {
                                            text-align: center;
                                            font-weight: bold;
                                        }


                                        .calSchedule .schedTab tr.dinside td.w7day
                                        {
                                        width: 20%!important;  
                                        max-width: 20%!important;
                                        overflow-x: scroll;
                                        height: 120px;


                                        text-wrap-mode:nowrap;
                                        
                                        background-color: #fdfdfd;
                                        border: 1px solid #ddd;

                                        vertical-align: top;
                                        }

                                        .calSchedule .schedTab tr.dinside td.w7day:hover
                                        {
                                        background-color: #dfdfdf;
                                        }

                                        .calSchedule .timeView
                                        {
                                        color: #888;
                                        }

                                        .calSchedule .labBar
                                        {
                                        width: 30px;
                                        margin-left: 3px;
                                        margin-right: 3px;   
                                        display: inline-block;  
                                        height: 80px;
                                        bbborder: 1px solid #ccc;
                                        vertical-align: bottom;
                                        font-size: 10px;
                                        text-align: center;
                                        }

                                        .calSchedule .timeBar
                                        {
                                        width: 30px;
                                        min-height: 1%;
                                        background-color: #00AA00; 
                                        }

                                        .calSchedule .schedTab tr.dinside td.w7day:hover  .timeBar:hover
                                        {   
                                        cursor: pointer;
                                        }






                               </style> 


                           </head>
                           <body class="epdf">` + 
        handle.outerHTML + "</body>";


        getData(html); 
              
    }

    const goPrint = () => {

        //const rows = props.tabRef.current?.rows;
   
        printElm(props.tabRef.current);
    }




    if(props.title != null && props.title != title)
    {
        setTitle(props.title);
    }



    if(status == 1)
        {
            return (
                <span>
                    ...
                </span>
            )  
        }



        

        if(status == 2 && stream.length > 10)
            {                                 
                                return (
                                    <span >                                       
                                        <span onClick={goPrint} className="plg_link">PDF</span>
                                        <sup className="gohide"> <a href={"data:application/pdf;base64," + stream} download={  title +  ".pdf"  } ref={linkRef}>otwórz</a> </sup>
                                    </span>                                                   
                                )                            
            } 
        


    return (
        <span onClick={goPrint} className="plg_link">PDF</span>
    )
}


export default HtmlToPDF;